import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, signal, WritableSignal, computed, Signal, HostListener, NgZone } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import * as _ from 'lodash';
import { IEntity } from '../../models/entity.interface';
import { MeService } from '../../services/me.service';
import { UiBtnFabComponent } from '../ui-btn-fab/ui-btn-fab.component';
import { UiEntityViewComponent } from '../ui-entity-view/ui-entity-view.component';
import { UiScrollableComponent } from '../ui-scrollable/ui-scrollable.component';
import { UiToolbarTopComponent } from '../ui-toolbar-top/ui-toolbar-top.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

export interface IEntityListView {
  entity: IEntity,
  list: Array<IEntity>,
}

@Component({
  selector: 'ui-entity-list-view',
  templateUrl: './ui-entity-list-view.component.html',
  styleUrls: ['./ui-entity-list-view.component.css'],
  imports: [UiToolbarTopComponent, MatIconButton, MatIcon, UiEntityViewComponent, UiBtnFabComponent, CdkScrollable]
})
export class UiEntityListViewComponent
  extends UiScrollableComponent
  implements OnInit {


  @Input('data')
  public data!: IEntityListView;

  @Output('back')
  public back = new EventEmitter<void>();

  @ViewChild('content', { static: false, read: ElementRef<HTMLElement> })
  set content(element: ElementRef<HTMLElement>) {
    this.scrollElement = element;
  }

  @ViewChild('entityView', { static: false })
  public entityView?: UiEntityViewComponent;


  public get changed(): boolean { return (this.entityDataChanged || this.entityView?.changed) ?? false; }
  private entityDataChanged: boolean = false;

  public get entity(): IEntity { return this.data.entity; }
  public get list(): Array<IEntity> { return this.data.list; }

  // document array
  public get numIds(): number { return this.list.length; }
  public currentIdx: WritableSignal<number> = signal(0);
  public currentId: Signal<string> = computed(() => this.list[this.currentIdx()].id);

  // current entity
  public get title(): string {

    if (!this.scrolledMin())
      return '';

    if (this.entityView?.view)
      return (this.entityView.view.name || this.id) ?? '';
    else
      return (this.entity?.name || this.id) ?? '';
  }

  public get subtitle(): string {

    if (!this.scrolledMin())
      return '';

    return this.id ?? '';
  }

  public get id(): string | null {
    if (this.entityView?.view)
      return this.me.getPathLast(this.entityView.view.id) ?? null;
    else
      return this.me.getPathLast(this.entity?.id) ?? null;
  }


  override ngOnInit(): void {

    // call base implementation
    super.ngOnInit();

    // if no list => create one
    if (!this.data.list)
      this.data.list = [this.data.entity];
    else {
      // find position within list
      let idx = _.indexOf(this.data.list, this.data.entity);
      if (idx < 0)
        idx = 0;
      this.currentIdx.set(idx);
    }

  }


  ////////////////////////////////////////////
  // next / previous

  public get canNext() { return this.currentIdx() < this.list.length - 1; }

  public onNext() {

    if (this.canNext)
      this.currentIdx.update(idx => idx + 1);

  }

  public get canPrev() { return this.currentIdx() > 0; }

  public onPrev() {

    if (this.canPrev)
      this.currentIdx.update(idx => idx - 1);

  }


  ////////////////////////////////////////////
  // swipe

  public onSwipeLeft() {

    if (this.canNext)
      this.onNext();

  }

  public onSwipeRight() {

    if (this.canPrev)
      this.onPrev();

  }

  ////////////////////////////////////////////
  // back
  public get backVisible(): boolean {
    return this.back.observed;
  }

  public onBack() {
    this.back.emit();
  }

  ////////////////////////////////////////////////
  // keyboard

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {

    // ignore when any dialog open
    if (this.me.topDialog)
      return;

    if (event.key === 'Escape') {

      if (this.bottomSheet._openedBottomSheetRef)
        return;

      this.onBack();
    }
  }

  constructor(public override me: MeService,
    renderer: Renderer2,
    host: ElementRef,
    scrollDispatcher: ScrollDispatcher,
    private bottomSheet: MatBottomSheet,
    ngZone: NgZone) {

    super(me, renderer, host, scrollDispatcher, ngZone);

  }

}
